export default __webpack_public_path__ + "static/media/IMG_2450.d9bb820f.jpg";